const buttonShadow = '0 2px 4px 0px rgba(26, 26, 26, 0.2)';
const buttonStyles = (tokens) => ({
    baseStyle: {
        fontWeight: 500,
        fontSize: tokens.FontSize1,
        minH: 12,
        boxShadow: buttonShadow,
        borderRadius: tokens.BorderRadius04,
    },
    variants: {
        select: {
            boxShadow: 'none',
            background: tokens.Layer02,
            borderWidth: tokens.BorderWidth01,
            color: tokens.TextLight500,
            height: '40px',
            fontSize: tokens.TextBodyReg3FontSize,
            textAlign: 'left',
            borderColor: tokens.BorderLight500,
            borderRadius: tokens.BorderRadius02,
            _hover: {
                background: tokens.Layer01,
                borderColor: tokens.BorderLight500,
            },
            _focus: {
                outlineColor: tokens.BorderFocus,
                outlineOffset: '2px',
                outlineWidth: '2px',
                borderColor: tokens.BorderDark800,
                color: tokens.TextBlack800,
                background: tokens.Layer01,
            },
            _focusVisible: {
                shadow: 'none',
            },
        },
        'white-grey': {
            boxShadow: 'none',
            background: tokens.ButtonSecondaryBgFillHover,
            borderWidth: tokens.BorderWidth01,
            borderColor: tokens.BorderLight500,
            color: tokens.TextLight500,
            _focus: {
                outlineColor: tokens.BorderFocus,
                outlineWidth: tokens.BorderWidth02,
            },
            _focusVisible: {
                boxShadow: 'none',
            },
        },
        primary: {
            background: tokens.ButtonPrimaryBgFill,
            color: tokens.ButtonPrimaryText,
            minW: 24,
            _hover: {
                background: tokens.ButtonPrimaryBgFillHover,
                color: tokens.ButtonPrimaryTextHover,
            },
            _active: {
                background: `${tokens.ButtonPrimaryBgFillPressed}!important`,
                color: tokens.ButtonPrimaryTextPressed,
                boxShadow: 'none',
            },
            _focus: {
                shadow: 'none',
                boxShadow: 'none',
                background: `${tokens.ButtonPrimaryBgFillHover}!important`,
            },
            _focusVisible: {
                outlineColor: tokens.BorderFocus,
                outlineOffset: tokens.BorderWidth02,
                outlineWidth: tokens.BorderWidth02,
                background: `${tokens.ButtonPrimaryBgFillHover}!important`,
                boxShadow: 'none',
            },
            _loading: {
                background: tokens.ButtonPrimaryBgFillPressed,
                color: tokens.ButtonPrimaryTextPressed,
                _hover: {
                    background: tokens.ButtonPrimaryBgFillHover,
                    color: tokens.ButtonPrimaryTextHover,
                },
            },
            _disabled: {
                background: tokens.ButtonPrimaryDisableFill,
                color: tokens.ButtonPrimaryText,
                boxShadow: 'none',
                _hover: {
                    background: `${tokens.ButtonPrimaryDisableFill}!important`,
                    color: `${tokens.ButtonPrimaryText}!important`,
                },
            },
        },
        secondary: {
            background: tokens.ButtonSecondaryBgFill,
            color: tokens.ButtonSecondaryText,
            borderColor: tokens.ButtonSecondaryBorder,
            borderWidth: tokens.BorderWidth01,
            minW: 24,
            _hover: {
                background: tokens.ButtonSecondaryBgFillHover,
                color: tokens.ButtonSecondaryTextHover,
                borderColor: tokens.ButtonSecondaryBorderHover,
            },
            _active: {
                background: tokens.ButtonSecondaryBgFillPressed,
                color: tokens.ButtonSecondaryTextPressed,
                borderColor: tokens.ButtonSecondaryBorderPressed,
                boxShadow: 'none',
            },
            _focus: {
                shadow: 'none',
                boxShadow: 'none',
            },
            _focusVisible: {
                outlineColor: tokens.BorderFocus,
                outlineOffset: tokens.BorderWidth02,
                outlineWidth: tokens.BorderWidth02,
                boxShadow: 'none',
            },
            _disabled: {
                opacity: 0.4,
            },
        },
        cancel: {
            borderWidth: tokens.BorderWidth01,
            borderColor: tokens.BorderError,
            color: tokens.TextError,
            background: 'white',
            _hover: {
                background: tokens.CanvasErrorLight,
            },
            _focus: {
                shadow: 'none',
                boxShadow: 'none',
            },
            _focusVisible: {
                outlineColor: tokens.BorderFocus,
                outlineOffset: tokens.BorderWidth02,
                outlineWidth: tokens.BorderWidth02,
                shadow: 'none',
            },
        },
        ghost: {
            boxShadow: 'none',
            _hover: {
                bgColor: 'transparent',
            },
            _active: {
                bgColor: 'transparent',
            },
            _focus: {
                background: 'transparent!important',
            },
            _focusVisible: {
                background: 'transparent!important',
            },
        },
        'no-focus': {
            boxShadow: 'none!important',
            _focus: {
                outline: 'none!important',
                boxShadow: 'none!important',
            },
            _focusVisible: {
                outline: 'none!important',
                boxShadow: 'none!important',
            },
        },
        solid: {
            boxShadow: 'none',
        },
        nav: {
            w: '68px',
            h: '72px',
            shadow: 'none',
            outline: 'none',
            alignSelf: 'flex-start',
            _focus: {
                shadow: 'none',
                boxShadow: 'none',
            },
            _focusVisible: {
                outlineColor: tokens.BorderFocus,
                outlineOffset: tokens.BorderWidth02,
                outlineWidth: tokens.BorderWidth02,
                borderRadius: 'none',
                boxShadow: 'none',
            },
            p: {
                w: '70px',
            },
            div: {
                pt: '18px',
                paddingInlineEnd: '3px',
            },
        },
    },
});
export default buttonStyles;
